import React from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";

import styles from "./styles.module.scss";
import images from '@/images';

export const CompanyLogoImage = ({ mode, className }) => {
    const { t } = useTranslation();

    return mode ? (
        <img className={cn(styles.logo, className)} src={mode} alt={t("companyLogotype")} />
    ) : (
        <div className={cn(styles.logo, styles["logo--empty"], className)}>
           <img src={images.photo_without_plus} alt="..." />
        </div>
    );
};

export const CompanyLogo = ({ onClick, mode }) => (
    <button
        className={cn(styles.button, !mode && styles.button__empty)}
        onClick={onClick}
        type="button"
    >
        {mode && <CompanyLogoImage mode={mode} />}
        <span className={styles.editIcon} />
    </button>
);
